import React, { FunctionComponent } from 'react';
import { Combobox } from '@vwfs-bronson/bronson-react';
import { FormField } from '../FormField/FormField';

export interface SearchableSelectOption {
  key: string;
  value: string;
}

export interface SearchableSelectProps {
  id: string;
  name: string;
  options: SearchableSelectOption[];
  value: SearchableSelectOption[];
  onChange: (value: SearchableSelectOption[]) => void;
  noOptionsMessage: string;
  placeholder: string;
  searchInputLabel: string;
  isDisabled?: boolean;
}

export const SearchableSelect: FunctionComponent<SearchableSelectProps> = ({
  id,
  name,
  options,
  value,
  onChange,
  noOptionsMessage,
  placeholder,
  searchInputLabel,
  isDisabled = false,
}) => {
  const handleKeyDownCapture = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === ' ' && event.target instanceof HTMLInputElement && event.target.type === 'search') {
      event.stopPropagation();
    }
  };

  return (
    <div onKeyDownCapture={handleKeyDownCapture}>
      <Combobox
        id={id}
        name={name}
        noOptionsMessage={noOptionsMessage}
        value={value}
        multiple={false}
        onChange={(selectedOptions) => onChange(selectedOptions as SearchableSelectOption[])}
        options={options}
        placeholder={placeholder}
        searchInputLabel={searchInputLabel}
        searchable
        disabled={isDisabled}
        aria-disabled={isDisabled}
      />
    </div>
  );
};

// use this component ONLY when using SearchableSelect within a Formik form, otherwise use SearchableSelect directly

export const SearchableSelectFormField: FunctionComponent<SearchableSelectProps> = (props) => {
  return (
    <FormField
      type="searchable-select"
      name={props.name}
      labelText={props.searchInputLabel}
      render={() => <SearchableSelect {...props} />}
    />
  );
};
